angular
  .module('fca-used')
  .factory('ResultHelper', ResultHelper);

ResultHelper.$inject = ['$localStorage', 'CONFIG'];

function ResultHelper($localStorage, CONFIG) {
  var resultHelper = {};

  resultHelper.filters = undefined;
  resultHelper.firstSearch = true;
  resultHelper.search = 0;
  resultHelper.setCount = function (count) {
    resultHelper.firstSearch = false;
    resultHelper.search++;
    resultHelper.vehiclesCount = count;
  };

  resultHelper.getCount = function () {
    return resultHelper.vehiclesCount;
  };

  resultHelper.ordered = false;
  resultHelper.vehiclesCount = 0;

  resultHelper.reset = function () {
    delete $localStorage.lastQuery;
    delete resultHelper.lastQuery;
    delete resultHelper.filters;

    resultHelper.search = 0;
    resultHelper.vehiclesCount = 0;
    resultHelper.firstSearch = true;
  };

  resultHelper.getLastQuery = function () {
    return angular.copy(resultHelper.lastQuery);
  };

  resultHelper.setLastQuery = function (query) {
    resultHelper.lastQuery = query;
  };

  resultHelper.getUvlVolumeMax = function () {
    return resultHelper.uvlMax || angular.copy($localStorage.uvlMax) || CONFIG.search.volume.max;
  };

  resultHelper.setUvlVolumeMax = function (max) {
    $localStorage.uvlMax = max;
    resultHelper.uvlMax = max;
  };

  return resultHelper;
}
